$('a[href^="#"]').on('click', function(event) {
  const hashValue = this.hash
  const $hash = $(hashValue);

  if ($hash.length == 0) {
    return
  }

  event.preventDefault();

  $('html, body').animate({
    scrollTop: $hash.offset().top
  }, 800, function(){
    window.location.hash = hashValue;
  });
});
